import { Login } from 'src/pages/Login';
import { AdminHomePage } from 'src/pages/AdminHomePage';
import '../assests/css/App.css';
import { Routes, Route } from 'react-router-dom';
import { Register } from 'src/pages/Registration';
import ProtectedRoute from 'src/components/ProtectedRoute';
import { DealerHomePage } from 'src/pages/DealerHomePage';
import { UserManagementPage } from 'src/pages/UserManagementPage';
import { EndUserHomePage } from 'src/pages/EndUserHomePage';
import { EndUserInstanceHomePage } from 'src/pages/EndUserInstanceHomePage';
import { ResetPasswordPage } from 'src/pages/ResetPasswordPage';
import { ForgotPasswordPage } from 'src/pages/ForgotPasswordPage';
import { OrderManagementPage } from 'src/pages/OrderManagementPage';
import { DashboardPage } from 'src/pages/DashboardPage';
import { SearchPage } from 'src/pages/SearchPage';

function App() {

        return (
                <>
                        <Routes>
                                <Route path='/' element={<Login />} />
                                <Route path='/Register' element={<Register />} />
                                <Route path='/ResetPassword' element={<ResetPasswordPage />} />
                                <Route path='/ForgotPassword' element={<ForgotPasswordPage />} />
                                <Route path='/' element={<ProtectedRoute />}>
                                        <Route path='/dashboard' element={<DashboardPage />} />
                                </Route>
                                <Route path='/' element={<ProtectedRoute />}>
                                        <Route path='/dealers' element={<AdminHomePage />} />
                                </Route>
                                <Route path='/' element={<ProtectedRoute />}>
                                        <Route path='/endUsers' element={<DealerHomePage />} />
                                </Route>
                                {/* <Route path='/' element={<ProtectedRoute />}> */}
                                {/*         <Route path='/search' element={<SearchPage />} /> */}
                                {/* </Route> */}
                                <Route path='/' element={<ProtectedRoute />}>
                                        <Route path='/users' element={<UserManagementPage />} />
                                </Route>
                                <Route path='/' element={<ProtectedRoute />}>
                                        <Route path='/orders' element={<OrderManagementPage />} />
                                </Route>
                                {/* <Route path='/' element={<ProtectedRoute />}> */}
                                {/*         <Route path='/endUserHome' element={<EndUserHomePage />} /> */}
                                {/* </Route> */}
                                {/* <Route path='/' element={<ProtectedRoute />}> */}
                                {/*         <Route path='/endUserInstanceHome' element={<EndUserInstanceHomePage />} /> */}
                                {/* </Route> */}
                        </Routes>
                </>
        );
}

export default App;
